import React, {useContext, useEffect, useState} from 'react';

import Steper from "../../../components/reunioes/reunioesRegister/reuniaoSteper";
import FormHeader from "../../../components/shared/form/formHeader";

import AbaSobre from "../../../components/reunioes/reunioesRegister/reuniaoAbas/reuniaoAbaSobre";
import AbaPauta from "../../../components/reunioes/reunioesRegister/reuniaoAbas/reuniaoAbaPauta";
import AbaDoc from "../../../components/reunioes/reunioesRegister/reuniaoAbas/reuniaoAbaDocumentos";
import AbaUsers from "../../../components/reunioes/reunioesRegister/reuniaoAbas/reuniaoAbaConvidados";
import AbaMesa from "../../../components/reunioes/reunioesRegister/reuniaoAbas/reuniaoMesa";
import AbaFormulario from "../../../components/reunioes/reunioesRegister/reuniaoAbas/reuniaoAbaFormulario";

import Button from '@material-ui/core/Button';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';

import {withRouter} from 'react-router-dom';

import {convocacaoReuniao, getById} from '../../../services/reuniao/ReuniaoService';

import moment from 'moment';
import {AppContext} from "../../../components/shared/context";
import TipoPerfil from "../../../constants/tipoPerfil";

const opcoes = [
  "Sobre",
  "Pauta e Ata",
  "Documentos",
  "Convidados",
  "Disposição da mesa",
  "Formulário",
  // "Fotos e Vídeos"
];


const EditarReuniao = (props) => {

  const { history } = props;

  const id = props.match.params.id;

  const initialState = {
    edicao: 1,
    periodicidade: '',
    conselho: '',
    data: '09/09/2018',
    hora: '',
    cep: '',
    estado: { "id": null, "nome": "" },
    cidade: '',
    endereco: '',
    descricao: '',
    expediente: '',
    ordem: '',
    comunicacoes: '',
    outros: '',
    arquivos: [],
    usuariosConvidados: [],
    cidadesDisponiveis: null,
    mesa: {
      cadeira1: '',
      cadeira2: '',
      cadeira3: '',
      cadeira4: '',
      cadeira5: '',
      cadeira6: '',
      cadeira7: '',
      cadeira8: '',
      cadeira9: '',
      cadeira10: '',
      cadeira11: '',
      cadeira12: '',
      cadeira13: '',
      cadeira14: '',
      cadeira15: '',
      cadeira16: '',
      cadeira17: '',
      cadeira18: '',
      cadeira19: '',
      cadeira20: '',
      cadeira21: '',
      cadeira22: '',
      cadeira23: '',
      cadeira24: '',
      cadeira25: '',
      cadeira26: '',
      cadeira27: '',
      cadeira28: '',
      cadeira29: '',
      cadeira30: '',
      cadeira31: '',
      cadeira32: '',
      cadeira33: '',
    },
    fotos: [],
    videos: [],
    audios: [],
    formulario: {
      id: null,
      nome: null,
      status: null,
      dataInicio: null,
      dataLimite: null,
      preenchimentos: []
    }
  };

  const [dadosReuniao, setDadosReuniao] = useState(initialState);

  const [aba, setAba] = useState(0);
  const [validados, setValidados] = useState({
    "Sobre": {
      validado: false,
    },
    "Pauta e Ata": {
      validado: false,
    },
    "Documentos": {
      validado: false,
    },
    "Convidados": {
      validado: false,
    },
    "Mesa": {
      validado: false,
    },
    // "Fotos": {
    //   validado: false,
    // },
    "Formulário": {
      validado: false,
    },
  })

  const handleChange = (aba, num) => {
    setAba(num);
  }

  const { role } = useContext(AppContext);

  const [mostrarNovaReuniao, setMostarNovaReuniao] = useState(false);

  const [reuniaoPassada, setReuniaoPassada] = useState(false);

  const [convocacaoEnviada, setConvocacaoEnviada] = useState(false);

  const handleConvocacao = async (id) => {
    await convocacaoReuniao(id);
    setConvocacaoEnviada(true);
  }

  useEffect(() => {
    setMostarNovaReuniao(TipoPerfil.EQUIPE_TECNICA.is(role));
    getById(id).then((response) => {
      if (response && response.status === 200) {
        const { data } = response;
        let stringData = moment(data.data).format('DD/MM/YYYY');
        let stringHora = moment(data.data).format('HH:mm');
        data.arquivos = [];     
        data.usuariosConvidados = [];  
        data.conselho = data.idConselho;
        data.data = stringData;
        data.hora = stringHora;
        data.expediente = data.pauta;
        data.estado = {nome: data.estado}
        data.mesa = {
          cadeira1: '',
          cadeira2: '',
          cadeira3: '',
          cadeira4: '',
          cadeira5: '',
          cadeira6: '',
          cadeira7: '',
          cadeira8: '',
          cadeira9: '',
          cadeira10: '',
          cadeira11: '',
          cadeira12: '',
          cadeira13: '',
          cadeira14: '',
          cadeira15: '',
          cadeira16: '',
          cadeira17: '',
          cadeira18: '',
          cadeira19: '',
          cadeira20: '',
          cadeira21: '',
          cadeira22: '',
          cadeira23: '',
          cadeira24: '',
          cadeira25: '',
          cadeira26: '',
          cadeira27: '',
          cadeira28: '',
          cadeira29: '',
          cadeira30: '',
          cadeira31: '',
          cadeira32: '',
          cadeira33: '',
        };

        data.fotos = [];
        data.videos = [];
        data.audios = [];
        
        setDadosReuniao((prevData) => ({...prevData, ...data}));
        // setDadosReuniao(data);

        setReuniaoPassada(reuniaoPassadaCalculo(data.data + ' ' + data.hora));
      }
    })
  }, [])

  const abaAtiva = (num) => {
    switch (num) {
      case 0:
        return <AbaSobre dados={dadosReuniao} updateDados={setDadosReuniao} handleStepper={setAba} validar={validados["Sobre"]} history={history}/>;
      case 1:
        return <AbaPauta isEdicao dados={dadosReuniao} updateDados={setDadosReuniao} handleStepper={setAba} validar={validados["Pauta e Ata"]} history={history}/>;
      case 2:
        return <AbaDoc isEditar dados={dadosReuniao} updateDados={setDadosReuniao} handleStepper={setAba} validar={validados["Documentos"]} history={history}/>;
      case 3:
        return <AbaUsers isEditar dados={dadosReuniao} updateDados={setDadosReuniao} handleStepper={setAba} validar={validados["Convidados"]} history={history}/>;
      case 4:
        return <AbaMesa isEditar dados={dadosReuniao} updateDados={setDadosReuniao} handleStepper={setAba} validar={validados["Mesa"]} history={history} />;
        // case 5:
        //   return <AbaFoto dados={dadosReuniao} updateDados={setDadosReuniao} handleStepper={setAba} validar={validados["Fotos"]} />;
      case 5:
        return <AbaFormulario isEditar dados={dadosReuniao} updateDados={setDadosReuniao} handleStepper={setAba} validar={validados["Formulário"]} history={history} />;
    }
  }

  const reuniaoPassadaCalculo = (dtStr) => {

    let dateParts = dtStr.split("/");
    let timeParts = dateParts[2].split(" ")[1].split(":");
    dateParts[2] = dateParts[2].split(" ")[0];

    let dia = new Date(dateParts[2], dateParts[1] - 1, dateParts[0], timeParts[0], timeParts[1]);

    if (!dia) {
      return true;
    }

    let hoje = new Date();
    let diaReuniao = new Date(dia);
    return hoje.getTime() - diaReuniao.getTime() >= 0;
  }

  function calculoDias() {

    var dataConvocacao = new Date(dadosReuniao.dataConvocacao);
    var hoje = new Date();
    var timeDiff = Math.abs(hoje.getTime() - dataConvocacao.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (diffDays > 7) {
      return true;
    } else {
      return false;
    }

  }

  return (
    <>
      <FormHeader isEditar titulo="Editar reunião" />
      <div style={{ position: 'relative', top: 120, padding: '0 24px' }}>
        <Steper isEditar indexAtivo={aba} opcoes={opcoes} clickHandle={handleChange} />
      </div>
      <div onClick={() => history.push(`/reuniao/${id}/visualizar`)} style={{ position: 'absolute', top: 24, left: 24, color: '#fff', display: 'flex', alignItems: 'center' }}>
        <ArrowBackIosRoundedIcon /><p>Voltar</p>
      </div>
      <div style={{ position: 'absolute', top: 24, right: 24 }}>
        {/*<Button variant="outlined"> Salvar alterações</Button>*/}
        {(calculoDias() && dadosReuniao.usuariosConvidados.length > 0 && !reuniaoPassada && aba === 4 && mostrarNovaReuniao && !convocacaoEnviada) && <Button style={{ marginLeft: 10 }} onClick={() => handleConvocacao(id)} variant="contained"> Enviar convocação</Button>}
      </div>
      <div>
        {abaAtiva(aba)}
      </div>
    </>
  );
}

export default withRouter(EditarReuniao);
